import { render, staticRenderFns } from "./DataPersonsUpdate.vue?vue&type=template&id=1699fad9"
import script from "./DataPersonsUpdate.vue?vue&type=script&lang=js"
export * from "./DataPersonsUpdate.vue?vue&type=script&lang=js"
import style0 from "./DataPersonsUpdate.vue?vue&type=style&index=0&id=1699fad9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports